export default __webpack_public_path__ + "static/media/txt_title.6a751da7.svg";